import { themes, type ThemeKey } from './themes';

/** 콘텐츠 월(슬라이드업 시트)이 쓰는 공통 색 토큰 */
export const CONTENT_BASE = '#ffffff';
export const CONTENT_INK = '#141210';
export const CONTENT_MUTED = '#8a827b';
export const CONTENT_BORDER = 'rgba(20,18,16,0.09)';
/** '0원 / 무료' 같은 긍정 지표용 그린 */
export const CONTENT_GREEN = '#3E8E5A';

/** 현재 테마의 시그니처 색 */
export const accentOf = (theme: ThemeKey): string => themes[theme].bg;